import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Carrot, Utensils, CookingPot, ShoppingBasket } from "lucide-react";

const ProductTabs = ({ activeTab, onTabChange }) => {
    const { t } = useTranslation();
    
    const tabs = [
        { id: 'all', label: t('products.all'), icon: null },
        { id: 'homemade', label: t('products.homemade'), icon: CookingPot },
        { id: 'bought', label: t('products.bought'), icon: ShoppingBasket }
    ];

    return (
        <div className="mb-8">
            <div className="flex gap-8">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`font-inter text-ps-blue-dark pb-2 relative inline-flex items-center gap-2
                            ${activeTab === tab.id ? 'font-medium' : 'hover:text-ps-blue-dark/70'}
                            after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full 
                            after:h-[2px] after:bg-gray-200
                            ${activeTab === tab.id ? 'after:bg-ps-blue-dark after:h-[3px]' : 'after:bg-gray-200'}
                        `}
                    >
                        <span className="flex items-center">
                            {tab.icon && React.createElement(tab.icon, {
                                className: tab.id === 'homemade' ? 'text-ps-orange' : 'text-ps-blue',
                                size: 20
                            })}
                        </span>
                        <span>{tab.label}</span>
                    </button>
                ))}
            </div>
            <div className="h-[2px] w-full bg-gray-200 -mt-[2px]" />
        </div>
    );
};

ProductTabs.propTypes = {
    activeTab: PropTypes.string.isRequired,
    onTabChange: PropTypes.func.isRequired
};

export default ProductTabs;